import { Box, IconButton, Menu } from '@mui/material'
import { MenuItemsStyle } from './UserPermissionView.style'
import PropTypes from 'prop-types'
import { ReactComponent as ViewPermissionIcon } from '../../../../assets/view_permission.svg'
import React, { useEffect, useState } from 'react'
import { webSocketWorkerEvent } from '../../../../services'

const UserPermissionView = ({ views }) => {
  const [selectView, setSelectView] = useState('')
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  useEffect(() => {
    webSocketWorkerEvent.sendEvent({ type: 'get_user_view', data: { view_was_changed: false } })
  }, [])

  useEffect(() => {
    const handelMessage = message => {
      if (message.data.type === 'get_user_view' && selectView !== message.data.data) {
        setSelectView(message.data.data.view)
      }
      if (['create_user_view', 'remove_user_view'].includes(message.data.type)) {
        webSocketWorkerEvent.sendEvent({ type: 'get_user_view', data: { view_was_changed: true } })
      }
    }
    webSocketWorkerEvent.addEventListener('message', handelMessage)
    return () => webSocketWorkerEvent.removeEventListener('message', handelMessage)
  }, [webSocketWorkerEvent])

  const handleMenuItemClick = item => {
    if (selectView === 'Default' && item !== 'Default') {
      webSocketWorkerEvent.sendEvent({ type: 'create_user_view', data: { view: item } })
    } else if (selectView !== 'Default' && item === 'Default') {
      webSocketWorkerEvent.sendEvent({ type: 'remove_user_view', data: {} })
    }
    setSelectView(item)
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        style={{ borderRadius: '4px' }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <ViewPermissionIcon />
      </IconButton>
      <Box
        sx={{
          position: 'absolute',
          top: '110px',
          right: '60px',
          transform: 'translate(-50%, -50%)',
          flexShrink: '0',
          padding: '20px',
          borderRadius: '4px'
        }}
      >
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          {views.map(item => (
            <MenuItemsStyle
              sx={{ margin: '1px !important' }}
              key={item}
              select={String(item === selectView)}
              onClick={() => handleMenuItemClick(item)}
            >
              {item}
            </MenuItemsStyle>
          ))}
        </Menu>
      </Box>
    </>
  )
}

export default UserPermissionView

UserPermissionView.propTypes = {
  views: PropTypes.array
}
